module.exports = __webpack_public_path__ + "img/2.df3162d8.png";